'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LOGIN_TYPE_OWNER = exports.LOGIN_TYPE_OWNER = 0;
var LOGIN_TYPE_MAINTENANCE = exports.LOGIN_TYPE_MAINTENANCE = 1;
var LOGIN_TYPE_MAINTENANCE_2 = exports.LOGIN_TYPE_MAINTENANCE_2 = 2;
var LOGIN_TYPE_CUSTOMER = exports.LOGIN_TYPE_CUSTOMER = 3;
var LOGIN_TYPE_CLERK = exports.LOGIN_TYPE_CLERK = 4;
var LOGIN_TYPE_ORGANIZATION = exports.LOGIN_TYPE_ORGANIZATION = 5;
var LOGIN_TYPE_GROUP_MANAGER = exports.LOGIN_TYPE_GROUP_MANAGER = 6;
var LOGIN_TYPE_GROUP_PASSENGER_CREATOR = exports.LOGIN_TYPE_GROUP_PASSENGER_CREATOR = 7;
var LOGIN_TYPE_GROUP_PASSENGER = exports.LOGIN_TYPE_GROUP_PASSENGER = 8;
var LOGIN_TYPE_REPORT = exports.LOGIN_TYPE_REPORT = 9;
var LOGIN_TYPE_WEB_COMPONENT = exports.LOGIN_TYPE_WEB_COMPONENT = 10;
var LOGIN_TYPE_CONGRESS_RESERVATION = exports.LOGIN_TYPE_CONGRESS_RESERVATION = 11;
var LOGIN_TYPE_NORMAL_RESERVATION = exports.LOGIN_TYPE_NORMAL_RESERVATION = 12;
var LOGIN_TYPE_CUSTOMER_NEW = exports.LOGIN_TYPE_CUSTOMER_NEW = 13;
var LOGIN_TYPE_WINRES_ADMIN = exports.LOGIN_TYPE_WINRES_ADMIN = 14;

var WinresUser = exports.WinresUser = function () {
  function WinresUser(loginResult, $filter, $scope) {
    var _this = this;

    _classCallCheck(this, WinresUser);

    this.loginResult = loginResult;
    this.$filter = $filter;
    this.buildRoles();
    $scope.$on('i18nextLanguageChange', function () {
      _this.buildRoles();
    });
    this.buildParameters();
  }

  // ** REQUIRED BY PORTAL **
  // Returns e.g. 
  // [
  //   { Code: "asiakaslista", Name: "" },
  // ]
  //
  // "asiakaslista" refers to the menu item name, Name overrides the menu 
  // title.


  _createClass(WinresUser, [{
    key: 'getAllowedMenuItems',
    value: function getAllowedMenuItems() {
      var controls = this.loginResult.UIDefinitions.UIControls;
      if (this.isAdmin()) {
        controls.push({ Code: 'parametrit' });
        controls.push({ Code: 'parametritaulukko' });
        controls.push({ Code: 'yp-varaukset' });
        var ulk = controls.findIndex(function (x) {
          return x.Code == 'ulkoiset-tuotteet';
        });
        controls.splice(ulk >= 0 ? ulk : controls.length - 1, 0, { Code: 'ulkoiset-jarjestelmat' });
      }
      return controls;
      // return [
      //     { Code: 'ryhma-matkustajat' },
      //     { Code: 'ryhma-hytit' },
      //     { Code: 'ryhma-maksut' },
      // ];
    }

    // ** REQUIRED BY PORTAL **
    // Returns e.g. "Jasper Mattsson" or "Comgate Oy", to be displayed in the 
    // top bar.

  }, {
    key: 'getDisplayName',
    value: function getDisplayName() {
      if (this.loginResult.FirstName != "" && this.loginResult.LastName != "") {
        return this.loginResult.FirstName + " " + this.loginResult.LastName;
      } else {
        return this.loginResult.Company;
      }
    }

    // ** REQUIRED BY PORTAL **
    // Returns e.g. https://www.asdf.com/logo.png. Should be on white background
    // or transparent.

  }, {
    key: 'getLogoUrl',
    value: function getLogoUrl() {
      return this.loginResult.UIDefinitions.Logo;
    }

    // ** REQUIRED BY PORTAL **
    // Returns e.g. { colorTopMenu: '#abc123' }

  }, {
    key: 'getColors',
    value: function getColors() {
      return this.loginResult.UIDefinitions.UIColors;
    }

    // ** REQUIRED BY PORTAL **
    // Returns connection name (which Winres).

  }, {
    key: 'getDomain',
    value: function getDomain() {
      var domain = this.loginResult.ConnectionName;
      return domain && domain.toLowerCase();
    }

    // ** REQUIRED BY PORTAL **
    // Returns e.g. [ { Name: 'Maintenance man', ID: 123 } ].

  }, {
    key: 'getAllowedRoles',
    value: function getAllowedRoles() {
      return this.roles;
    }

    // ** REQUIRED BY PORTAL API **

  }, {
    key: 'getStyle',
    value: function getStyle() {
      return this.loginResult.UIDefinitions.Style;
    }

    // ** REQUIRED BY PORTAL API **

  }, {
    key: 'getCurrentRoleId',
    value: function getCurrentRoleId() {
      return this.loginResult.CurrentRoleID;
    }

    // ** REQUIRED BY PORTAL API **
    // Used to hide the left menu in M-Files info boards (see app.html)

  }, {
    key: 'getShowMainMenu',
    value: function getShowMainMenu() {
      return true;
    }

    // Not required by Portal API.

  }, {
    key: 'getParameter',
    value: function getParameter(key) {
      key = key.toLowerCase();
      return key in this.parameters ? this.parameters[key] : null;
    }

    // Not required by Portal API.

  }, {
    key: 'getUserName',
    value: function getUserName() {
      return this.loginResult.UserID;
    }

    // Returns Winres Owner / Producer ID
    // Not required by Portal API.

  }, {
    key: 'getOwnerNumber',
    value: function getOwnerNumber() {
      return this.loginResult.OwnerNumber;
    }

    // Not required by Portal API.

  }, {
    key: 'getCustomerId',
    value: function getCustomerId() {
      return this.loginResult.WinresCustomerID;
    }

    // Not required by Portal API.

  }, {
    key: 'getBookingNumber',
    value: function getBookingNumber() {
      return this.loginResult.WinresBookingNumber;
    }

    // Not required by Portal API.

  }, {
    key: 'getOffice',
    value: function getOffice() {
      return this.loginResult.Office;
    }

    // Not required by Portal API.

  }, {
    key: 'getSessionId',
    value: function getSessionId() {
      return this.loginResult.SessionID;
    }

    // Not required by Portal API.

  }, {
    key: 'getEmail',
    value: function getEmail() {
      return this.loginResult.Email;
    }

    // Removed as unsafe.
    // // Not required by Portal API.
    // getAuth() {
    //     return this.loginResult.Auth;
    // }

    // Not required by Portal API.

  }, {
    key: 'getUserType',
    value: function getUserType() {
      return this.loginResult.UserType;
    }
  }, {
    key: 'isAdmin',
    value: function isAdmin() {
      return this.loginResult && this.loginResult.UserType === LOGIN_TYPE_WINRES_ADMIN;
    }

    // Not required by Portal API.

  }, {
    key: 'getImpersonatingAdmin',
    value: function getImpersonatingAdmin() {
      return this.loginResult.ImpersonatingAdmin;
    }

    // Sets role names based on user type and their respective IDs.

  }, {
    key: 'buildRoles',
    value: function buildRoles() {
      var _this2 = this;

      this.roles = _.clone(this.loginResult.AvailableRoles);
      _.each(this.roles, function (role) {
        if (!role.Name) {
          switch (role.WinresLoginType) {
            case LOGIN_TYPE_OWNER:
              role.Name = _this2.$filter('i18next')('role_titles.owner', {
                number: role.WinresOwnerID
              });
              break;
            case LOGIN_TYPE_MAINTENANCE:
              role.Name = _this2.$filter('i18next')('role_titles.maintenance', {
                number: role.WinresOwnerID
              });
              break;
            case LOGIN_TYPE_MAINTENANCE_2:
              role.Name = _this2.$filter('i18next')('role_titles.maintenance_2', { number: role.WinresOwnerID });
              break;
            case LOGIN_TYPE_CUSTOMER:
              role.Name = _this2.$filter('i18next')('role_titles.customer', {
                number: role.WinresCustomerID
              });
              break;
            case LOGIN_TYPE_CLERK:
              role.Name = _this2.$filter('i18next')('role_titles.clerk', {
                number: role.WinresClerkID
              });
              break;
            case LOGIN_TYPE_ORGANIZATION:
              // Probably not in use.
              role.Name = _this2.$filter('i18next')('role_titles.organization');
              break;
            case LOGIN_TYPE_GROUP_MANAGER:
              role.Name = _this2.$filter('i18next')('role_titles.group_manager', {
                number: role.WinresCustomerID
              });
              break;
            case LOGIN_TYPE_GROUP_PASSENGER_CREATOR:
              role.Name = _this2.$filter('i18next')('role_titles.group_passenger_creator', {
                number: role.WinresBookingNumber
              });
              break;
            case LOGIN_TYPE_GROUP_PASSENGER:
              role.Name = _this2.$filter('i18next')('role_titles.group_passenger_creator', {
                number: role.WinresBookingNumber,
                email: _this2.email
              });
              break;
            case LOGIN_TYPE_REPORT:
              role.Name = _this2.$filter('i18next')('role_titles.report');
              break;
            default:
              role.Name = _this2.$filter('i18next')('role_titles.unknown', {
                number: role.WinresLoginType
              });
              break;
          }
        }
      });
    }
  }, {
    key: 'buildParameters',
    value: function buildParameters() {
      var _this3 = this;

      this.parameters = {};
      _.each(this.loginResult.ParameterList, function (parameter) {
        _this3.parameters[parameter.Code.toLowerCase()] = parameter.Value;
      });
    }
  }]);

  return WinresUser;
}();


//////////////////
// WEBPACK FOOTER
// ./src/environment/winres/user.js
// module id = 542
// module chunks = 2